export interface ScheduledFsySunday {
  date: Date;
  week: 1 | 2 | 3 | 4;
  repeatsGuideStudy: boolean;
}

function startOfLocalDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function getSundaysInMonth(year: number, month: number): Date[] {
  const monthIndex = month - 1;
  const firstDay = new Date(year, monthIndex, 1);
  const daysUntilSunday = (7 - firstDay.getDay()) % 7;
  const firstSunday = 1 + daysUntilSunday;
  const sundays: Date[] = [];

  for (
    let day = firstSunday;
    new Date(year, monthIndex, day).getMonth() === monthIndex;
    day += 7
  ) {
    sundays.push(new Date(year, monthIndex, day));
  }

  return sundays;
}

export function mapSundayToFsyWeek(
  date: Date,
): Omit<ScheduledFsySunday, 'date'> | null {
  if (date.getDay() !== 0) {
    return null;
  }

  const sundays = getSundaysInMonth(
    date.getFullYear(),
    date.getMonth() + 1,
  );
  const sundayIndex = sundays.findIndex(
    (sunday) => sunday.getDate() === date.getDate(),
  );
  if (sundayIndex === -1) {
    return null;
  }

  if (sundayIndex === sundays.length - 1) {
    return { week: 4, repeatsGuideStudy: false };
  }
  if (sundayIndex < 3) {
    return {
      week: (sundayIndex + 1) as 1 | 2 | 3,
      repeatsGuideStudy: false,
    };
  }
  return { week: 1, repeatsGuideStudy: true };
}

export function getUpcomingFsySunday(
  today: Date,
  year: number,
  month: number,
): ScheduledFsySunday | null {
  const startToday = startOfLocalDay(today);
  const upcoming = getSundaysInMonth(year, month).find(
    (sunday) => sunday.getTime() >= startToday.getTime(),
  );
  if (!upcoming) {
    return null;
  }

  const mapping = mapSundayToFsyWeek(upcoming);
  return mapping ? { date: upcoming, ...mapping } : null;
}

export function formatFsySunday(date: Date): string {
  return new Intl.DateTimeFormat(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}
